import { checkDefined } from 'faro-common-model';
export var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["INACTIVE"] = "INACTIVE";
})(AccountStatus || (AccountStatus = {}));
/**
 * @return the built UserDetail DTO
 */
export function toUserDetail(userDetail) {
    checkDefined(userDetail.username, 'UserDetail', 'username');
    return {
        id: userDetail.id,
        username: userDetail.username.toLowerCase(),
        firstname: userDetail.firstname,
        lastname: userDetail.lastname,
        idpId: userDetail.idpId,
        idpSource: userDetail.idpSource,
        accountStatus: userDetail.accountStatus || AccountStatus.INACTIVE,
        tenantId: userDetail.tenantId,
        roles: userDetail.roles || [],
        accountType: userDetail.accountType || 'user',
        deleted: userDetail.deleted || false,
        created: userDetail.created,
        updated: userDetail.updated,
        updatedBy: userDetail.updatedBy,
    };
}
//# sourceMappingURL=user-detail.js.map